<template>
  <div>
    <v-btn class="exit-icon red-background" dark small @click="closeConsults">Close Consults</v-btn>

    <md-card>
      <md-card-content style="height: 80vh;overflow: auto;">
        <!-- Patient Info  Header -->
        <div class="md-layout md-gutter md-alignment-center">
          <div class="md-layout-item md-size-100">
            <md-card style="box-shadow: none;border-bottom: solid 1px #eee;border-radius: 0;margin: 0 0 1rem 0;">
              <!-- <md-card-header>Patient Info</md-card-header> -->
              <md-card-content>
                <p>
                  Patient:
                  <span style="font-size: 1.20rem; color:#3cb3a3; font-weight: 500;">
                    {{ mData.patient.firstname }} {{ mData.patient.lastname }}
                  </span>
                </p>
                <p>
                  Pupillary Distance:
                  <span style="color: darkgreen; font-weight: 500;">{{ getPD }}</span>
                </p>
                <p>DOB: {{ mData.patient.birthdate ? formattedDate(mData.patient.birthdate) : '-' }}</p>
                <p>SHOP: {{ mData.patient.shop_id }}</p>
              </md-card-content>
            </md-card>
          </div>
        </div>

        <div v-for="consult in mData.mConsults" class="md-layout md-gutter md-alignment-center">
          <div class="md-layout-item md-size-100"
            style="margin-left: 15px; font-weight: 400; color: #3cb3a3; font-size: .95rem;">
            {{ formatDateTime(consult) }} <br />
            <small style="color: black;">* Values are in {{ currentMode }} *</small>
          </div>

          <div v-for="measure in filteredMeasurements" class="md-layout-item "
            @click="captureMeasure(measure, consult)">
            <md-card class="md-with-hover green-border-hover"
              style="max-width: 280px; min-width: 243px;margin: 1rem auto">
              <md-card-content>
                <div style="color: #3cb3a3;">
                  <strong>{{ formatCType(measure.type) }}</strong>
                </div>
                <div class="card-grid">
                  <div class="card-header">
                    <small>&nbsp;&nbsp;&nbsp;&nbsp;</small>
                    <small>sphere | &nbsp;</small>
                    <small>cylinder | &nbsp;</small>
                    <small>axis | &nbsp;</small>
                    <small>add | &nbsp;</small>
                    <small>acuity</small>
                  </div>
                  <div v-if="measure.od" class="card-row">
                    <span class="card-label">OD:</span>

                    <span class="card-value">{{ getSphere(measure.od.sphere, measure.od.cylinder) }} <span
                        class="separator">|</span></span>

                    <span class="card-value">{{ getCylinder(measure.od.cylinder) }} <span
                        class="separator">|</span></span>

                    <span class="card-value">{{ getAxis(measure.od.axis) }}&deg;<span class="separator">|</span></span>
                    <span class="card-value">{{ getAdd(measure.od.add) }} <span class="separator">|</span></span>

                    <span class="card-value">{{ measure.od.acuity ? convertAcuity(measure.os.acuity) : "-" }}</span>
                  </div>

                  <div v-if="measure.os" class="card-row">
                    <span class="card-label">OS:</span>
                    <span class="card-value">{{ getSphere(measure.os.sphere, measure.os.cylinder) }} <span
                        class="separator">|</span></span>

                    <span class="card-value">{{ getCylinder(measure.os.cylinder) }} <span
                        class="separator">|</span></span>

                    <span class="card-value">{{ getAxis(measure.os.axis) }}&deg;<span class="separator">|</span></span>
                    <span class="card-value">{{ getAdd(measure.os.add) }} <span class="separator">|</span></span>

                    <span class="card-value">{{ measure.os.acuity ? convertAcuity(measure.os.acuity) : "-" }}</span>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>

          <div class="md-layout-item md-size-100"
            style="margin-left: 15px; font-weight: 400; color: #3cb3a3; font-size: .95rem;">
            <md-button :class="toggleClass" class="md-sm" @click="toggleCyl">
              Toggle CYL + / -
            </md-button>
          </div>
        </div>

        <!-- <div align="left"> -->
        <!-- <md-button :class="toggleClass" class="md-sm" @click="toggleCyl"> -->
        <!-- Toggle CYL + / - -->
        <!-- </md-button> -->
        <!-- class="md-sm" -->
        <!-- </div> -->
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment"
// import { Exception } from 'sass';
import Swal from "sweetalert2"
import { ThisMonthInstance } from "twilio/lib/rest/api/v2010/account/usage/record/thisMonth"
import { ItemAssignmentList } from "twilio/lib/rest/numbers/v2/regulatoryCompliance/bundle/itemAssignment"

export default {
  name: "ConsultsDetail",
  components: {},
  props: ["cDATA"],
  data() {
    return {
      consults: [],
      searchTxt: "",
      mToggleCyl: false, // false = PLUS - TRUE = MINUS
      currentMode: null,
      mData: {
        patient: {},
        mConsults: [],
        defaultCylinder: null
      }
    }
  },

  computed: {
    formattedConsultsDate() {
      return this.formatDateTime(this.mData.mConsults[0].date_time)
    },
    filteredMeasurements() {
      return this.mData.mConsults[0].measurements.slice(0, 4)
    },
    getPD() {
      if (this.mData.mConsults[0]) {
        return this.mData.mConsults[0].pupillary_distance
      } else {
        return 0
      }
    },
    cylmode() {
      return this.mToggleCyl ? "MINUS CYL" : "PLUS CYL"
    },
    toggleClass() {
      return this.mToggleCyl ? "md-primary" : "md-secondary"
    },
    sortedConsultations() {
      return this.consultations
      //   return this.consultations.sort((a, b) => {
      //     const dateA = new Date(a.consult);
      //     const dateB = new Date(b.consult);
      //     return dateA.getTime() - dateB.getTime(); // Reversed comparison
      //   });
    }
  },

  created: function () { },
  mounted: function () {
    // Map prop onto mData using the spread operator
    this.mData = { ...this.mData, ...this.cDATA }
    if (!this.cDATA.defaultCylinder) {
      this.currentMode = this.detectMode();
    }
    else {
      this.currentMode = this.cDATA.defaultCylinder;
      this.mToggleCyl = this.currentMode !== 'PLUS_CYLINDER';
    }
  },
  updated: function () { },
  destroyed: function () {
    document.getElementsByClassName('wrapper')[0].style = ''
  },

  methods: {
    getAdd(add) {
      return add ? add.toFixed(2) : add
    },
    formattedDate(date) {
      return new moment(date).format("MM/DD/YYYY")
    },
    closeConsults() {
      this.$emit("onCloseConsults")
    },
    formatDateTime(item) {
      if (item.date_time && item.date_time != "") return new moment(item.date_time).format("MM/DD/YYYY  |  h:mm a")
    },
    detectMode() {
      // find bino perceptual and verify if cylinder has negative values, if so it's is MINUS CYLINDER
      const values = this.filteredMeasurements.find(i => i.type === 'final_bino_perceptual');
      if (values) {
        const isMinusCyl = values.od.cylinder < 0 || values.os.cylinder < 0
        return isMinusCyl ? "MINUS CYL" : "PLUS CYL"
      } else {
        return 'PLUS CYL'
      }
    },
    formatCType(cType) {
      var retval = ""
      retval = String(cType).replaceAll("_", " ")
      retval = String(retval).replaceAll("final", "")
      return retval
    },
    getTotalConsults() {
      return this.mData.mConsults.length
    },
    toggleCyl() {
      this.mToggleCyl = !this.mToggleCyl
      if (this.currentMode === 'MINUS CYL') {
        this.currentMode = 'PLUS CYL'
      } else {
        this.currentMode = 'MINUS CYL'
      }
    },

    captureMeasure(m, c) {
      console.log("capture-Measure: ", m)
      console.log("capture-Consult: ", c)
      Swal.fire({
        title: "Dispensing SiView Rx",
        text: `Measures Selected: ${m.type}.`,
        type: "success",
        confirmButtonText: "OK"
      })
      this.xferToRx(m, c)
      this.closeConsults()

      // Swal.fire({
      //     title: 'Dispensing SiView Rx',
      //     text: `Measures Selected: ${m.type}.`,
      //     showCancelButton: true,
      //     confirmButtonText: "Proceed",
      // }).then((result) => {
      //     /* Read more about isConfirmed, isDenied below */
      //     if (result.isConfirmed) {
      //         this.xferToRx(m, c);
      //         this.closeConsults();
      //         Swal.fire("Measures Transferred!", "", "success");
      //     } else if (result.isDenied) {
      //         Swal.fire("No action taken", "", "info");
      //     }
      // });
    },

    async xferToRx(m, c) {
      let rxID = this.getScreeiningID(c)
      let svID = this.getSivewID(c)

      const route = "/prescription/" + rxID
      const url = process.env.VUE_APP_URL + route
      const config = {
        headers: {
          "Content-Type": "application/json"
          //'Access-Control-Allow-Origin': '*',
        }
      }
      var vm = this
      const data = {
        screeningID: rxID,
        patientID: vm.mData.patient.web_emr_id, //username
        siviewID: svID,
        prescriptionType: m.type.indexOf('contactlens') >= 0 ? 'contact' : 'glasses',
        // Add FN, LN, DOB to Prescription Info
        patient_DOB: vm.mData.patient.birthdate,
        patient_LN: vm.mData.patient.lastname,
        patient_FN: vm.mData.patient.firstname,

        sphereOD: m.od.sphere,
        sphereOS: m.os.sphere,
        cylinderOD: m.od.cylinder == 0 ? "SPH" : m.od.cylinder,
        cylinderOS: m.os.cylinder == 0 ? "SPH" : m.os.cylinder,
        axisOD: m.od.cylinder == 0 ? " " : m.od.axis,
        axisOS: m.os.cylinder == 0 ? " " : m.os.axis,
        powerOD: m.od.add,
        powerOS: m.os.add,
        distanceOD: this.getAcuity(m.od.acuity),
        distanceOS: this.getAcuity(m.os.acuity),
        commentsOU: "",
        approved: "",
        approvedBy: "",
        approvedOn: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        createdBy: "GlobeChekApp",
        createdAt: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        updatedBy: "GlobeChekApp",
        updatedAt: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ")
      }

      console.log("xferToRx:URL " + url)
      console.log("xferToRx:DATA " + data)
      /*  */
      await window.axios.post(url, data, config).catch(err => {
        console.log(err)
      })
    },

    getScreeiningID(c) {
      let retval = null
      if (this.mData.patient.client_number === undefined || this.mData.patient.client_number === null) {
        retval = this.getSivewID(c)
      } else {
        retval = this.mData.patient.client_number
      }

      if (retval == null) {
        alert("Screening ID not found!")
        return "not-found"
      } else {
        return retval
      }
    },

    getSivewID(c) {
      // Created-ID: shop-id + patient-id + consult-id
      return this.mData.patient.shop_id + "-" + this.mData.patient.id + "-" + c.id
    },

    getSphere(sph, cyl) {
      let value = null
      if (this.mToggleCyl) {
        value = sph + cyl // MINUS-CYL
      } else {
        value = +sph // PLUS-CYL
      }
      if (value) return Number(value).toFixed(2)
      return value
    },
    getCylinder(cyl) {
      let value = null
      if (this.mToggleCyl) {
        value = -Math.abs(cyl); // MINUS-CYL
      } else {
        value = Math.abs(cyl); // PLUS-CYL
      }
      if (value) return Number(value).toFixed(2)
      return value
    },
    getAxis(ax) {
      if (this.mToggleCyl) {
        // MINUS-CYL
        if (ax <= 91) {
          return ax + 90
        } else {
          return ax - 90
        }
      } else {
        // PLUS-CYL
        return +ax
      }
    },

    getAcuity(val) {
      return this.convertAcuity(val)
    },

    convertAcuity(val) {
      /**
       * Convert decimal visual acuity to Snellen fraction.
       * 
       * @param {number} decimalAcuity - Decimal value (e.g., 1. Ascending, 0.5, 0.25)
       * @returns {string} Snellen fraction (e.g., '20/20', '20/40')
       */
      if (val <= 0) {
        console.log("Invalid acuity value");
        return null
      }

      // Calculate the denominator (20 / decimal)
      const denominator = 20 / val;

      // Standard Snellen denominators for rounding
      const standardDenominators = [
        10, 15, 20, 25, 30, 40, 50, 60, 70, 100, 200, 400, 800
      ];

      // Find the closest standard denominator
      const closestDenominator = standardDenominators.reduce((prev, curr) =>
        Math.abs(curr - denominator) < Math.abs(prev - denominator) ? curr : prev
      );

      // Return the Snellen fraction
      return `20/${Math.round(closestDenominator)}`;
    }
  }
}
</script>

<!-- 
Initial Rx
A=Sphere
B=Cyl
C=degree

Converted Rx
X=Sphere
Y=Cyl
Z=degree


X=A+B
Y=function oppositesign B (always the opposite sign + >> -, - >> +)
Z=if (C <= 91; C+90 = Z.Result) else (C - 90; Z.result) 
-->

<style lang="sass" scoped>
.green-border-hover
  border: 2px solid #fff

.green-border-hover:hover
  border: 2px solid green !important

.green-border-hover:hover .card-value
    color: darkgreen
    font-weight: 600

.card-grid
  display: grid
  grid-template-columns: repeat(6, 1fr)
  gap: 10px

.card-header
  grid-column: span 6
  display: flex
  justify-content: space-between

.card-row
  grid-column: span 6
  display: flex
  justify-content: space-between
  align-items: center

.card-label
  font-weight: bold

.card-value
  display: flex
  align-items: center


.separator
  margin-left: 5px
  margin-right: 5px
  color: #666

.md-primary
  background-color: #007bff !important
  color: #ffffff !important


.md-secondary
  background-color: #6c757d !important
  color: #ffffff !important

.swal2-container
    z-index: 10000 !important
</style>
